import React, { Component } from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";

export default class SponsorCell extends Component {
  render() {
    var { user } = this.props;
    var {
      name,
      type,
      description,
      logo,
      banner,
      videourl,
      contactperson,
      email,
      phonenumber,
      weblink,
      facebook,
      linkedin,
      twitter,
      instagram,
      whatsapp,
    } = user;

    return (
      <tr
        style={
          user.hasErrors && user.hasErrors.length > 0
            ? { backgroundColor: "#ff000038" }
            : {}
        }
      >
        <td>
          <div className="vertical-align-center">
            {user.rowno}{" "}
            {user.hasErrors && user.hasErrors.length > 0 ? (
              <OverlayTrigger
                id="overlay-trigger"
                key="refresh"
                placement="top"
                overlay={
                  <Popover id="popover-basic">
                    {user.hasErrors.join(", ")}
                  </Popover>
                }
              >
                <i
                  className="fa fa-exclamation-circle"
                  aria-hidden="true"
                  style={{ float: "right", color: "red", margin: 7 }}
                ></i>
              </OverlayTrigger>
            ) : (
              ""
            )}
          </div>
        </td>
        <td>{name}</td>
        <td>{type}</td>
        <td>{description}</td>
        <td>{logo}</td>
        <td>{banner}</td>
        <td>{videourl}</td>
        <td>{contactperson}</td>
        <td>{email}</td>
        <td>{phonenumber}</td>
        <td>{weblink}</td>
        <td>{facebook}</td>
        <td>{linkedin}</td>
        <td>{twitter}</td>
        <td>{instagram}</td>
        <td>{whatsapp}</td>
      </tr>
    );
  }
}
